import {createSelector} from 'reselect';
import {getLocale} from './system';
import {getMap, getSystem, getTranslations} from './store';
import {
    getGeoCode,
    getGeography,
    getPropertyMapThumbnailUrl,
    getPropertyMapThumbnailUrlTwoColumn,
    getPropertyNotes
} from './listing';
import getListingPageModalStates from './modalStates';
import {getLocation} from './listingSummary';

const getLocationDescription = createSelector(
    [getPropertyNotes],
    (propertyNotes = []) => {
        for (let note of propertyNotes) {
            if (note.title === 'Local Description' && note.text && note.text.trim().length) {
                return note.text;
            }
        }

        return null;
    }
);

const getMapThumbnailAlt = createSelector(
    [getTranslations],
    (translations) => {
        return {
            propertyMapThumbnailAlt: translations.propertyMapThumbnailAlt
        };
    }
);

const getMapData = createSelector(
    [
        getLocale,
        getLocation,
        getLocationDescription,
        getMap,
        getGeoCode,
        getGeography,
        getSystem,
        getTranslations,
        getPropertyMapThumbnailUrl,
        getPropertyMapThumbnailUrlTwoColumn,
        getListingPageModalStates
    ],
    (
        locale,
        locationLabel,
        locationDescription,
        map,
        geoCode,
        geography,
        system,
        translations,
        propertyMapThumbnailUrl,
        propertyMapThumbnailUrlTwoColumn,
        listingPageModalStates
    ) => {
        const mapRegion = locale.substring(3, 5);
        const location = (geography && geography.location) || {};
        const geo = geoCode || {};
        const lat = geo.latitude || location.lat;
        const lng = geo.longitude || location.lng;
        const exact = !!(geo.latitude && geo.longitude && geo.exact);

        const labels = {
            openMap: translations.openMap,
            map: translations.navMap,
            location: locationLabel,
            more: translations.more
        };

        labels.toi = {
            detailedlocation: translations.toiDetailedLocation,
            distance: {
                fromrental: translations.toiDistanceFromrental
            },
            pagination: {
                next: translations.toiPaginationNext,
                of: translations.toiPaginationOf,
                prev: translations.toiPaginationPrev
            },
            rated: translations.toiRated,
            whatsnearby: translations.toiWhatsnearby,
            categoriesHighlights: translations.categoriesHighlights
        };

        const toiModalOpen = listingPageModalStates.toiModalOpen;
        const locationModalOpen = listingPageModalStates.locationModalOpen;

        return {
            unveiled: map.unveiled,
            exact,
            lat,
            lng,
            locationDescription,
            mapApiKey: map.apiKey,
            mapLanguage: locale,
            propertyMapThumbnailUrl,
            propertyMapThumbnailUrlTwoColumn,
            mapRegion,
            labels,
            siteName: system.siteName,
            toiModalOpen,
            locationModalOpen
        };
    }
);

export default getMapData;
export {getMapData, getLocationDescription, getMapThumbnailAlt};
